import styled from "styled-components";

export const AgentsViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 28px;
   /* XS - Mobile */
  padding: 0 16px;

  /* S - Tablet */
  @media (min-width: 600px) {
    padding: 0 24px;
  }

  /* M - Small laptop */
  @media (min-width: 1280px) {
    padding: 0 24px;
  }

  /* L - Default laptop */
  @media (min-width: 1440px) {
    padding: 0 32px;
  }

  /* XL - Widescreen */
  @media (min-width: 1920px) {
    padding: 0 80px;
  }
`;

export const TopContent = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  width: 100%;
  max-width: 1400px;
  height: 100%;
`;
export const BottomContent = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  max-width: 1400px;
  height: 100%;
  @media (max-width: 744px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
